import { Type } from '@angular/core';
import { ComponentRegistryService } from '../services/component-registry/component-registry.service';
import { CustomComponent } from '../models/CustomComponent.model';
import * as Components from '../components';
import { DunaEventInstructorsComponent } from '../components/duna/duna-event-instructors/duna-event-instructors.component';
import { DunaEventInstructorsRespondComponent } from '../components/duna/duna-event-instructors-respond/duna-event-instructors-respond.component';

let registered = false;

function isCustomComponent(component: unknown): component is Type<unknown> {
  return (
    typeof component === 'function' &&
    ('ɵcmp' in component || 'ɵcmp' in (component as Type<unknown>).prototype)
  );
}

function ensureRegistered(
  registry: ComponentRegistryService,
  name: string,
  componentClass: Type<unknown>
): void {
  if (!registry.getComponentRegistry().has(name)) {
    const customComponent = new CustomComponent(
      name,
      0,
      0,
      4,
      2,
      '',
      {},
      {},
      1
    );
    customComponent.component = componentClass;
    registry.registerComponent(name, customComponent);
  }
}

/** Register all CMS components before the first route renders. */
export function registerAppComponents(
  registry: ComponentRegistryService
): void {
  if (registered) {
    return;
  }

  Object.entries(Components).forEach(([key, component]) => {
    if (isCustomComponent(component)) {
      const customComponent = new CustomComponent(key, 0, 0, 4, 2, '', {}, {}, 1);
      customComponent.component = component;
      const sanitizedName = customComponent.name.replace(/^_+/, '');
      customComponent.name = sanitizedName;
      registry.registerComponent(sanitizedName, customComponent);
    }
  });

  ensureRegistered(
    registry,
    'DunaEventInstructorsComponent',
    DunaEventInstructorsComponent
  );
  ensureRegistered(
    registry,
    'DunaEventInstructorsRespondComponent',
    DunaEventInstructorsRespondComponent
  );

  registered = true;
}

export function createRegisterAppComponentsInitializer(
  registry: ComponentRegistryService
) {
  return () => {
    registerAppComponents(registry);
    return Promise.resolve();
  };
}
